import React from 'react';
import { Image, Divider } from 'semantic-ui-react';

const textCentered = {
  textAlign: 'center',
};

const DashboardCampaignsEmptyState = () => (
  <div style={textCentered}>
    <Divider hidden />
    <Divider hidden />
    <h2>You have nothing added as yet!</h2>
    <Image centered src="/images/nothing-added-yet.svg" />
    <Divider hidden />
    <h3>
      Choose to start building a campaign, or you can start adding your influencers immediately.
    </h3>
  </div>
);

export default DashboardCampaignsEmptyState;



/** WEBPACK FOOTER **
 ** ./src/components/dashboard-campaigns-empty-state/index.js
 **/